module.exports = __webpack_public_path__ + "static/mcconnellBourn-fea43cc9987d1e5369e4a7253ecaa964.svg";